// extracted by mini-css-extract-plugin
module.exports = {"dim":"admin-portal__AlertDialog__dim","dialog":"admin-portal__AlertDialog__dialog","buttonRow":"admin-portal__AlertDialog__buttonRow"};